import typeCheck from 'common/util/typeCheck';

import {
  SR_API_ACTION_GET_ASSIGNED_APARTMENT_LOCATOR_BY_RENTER_ID,
} from 'api/actionTypes';

export default async function getApartmentLocator({ state, apiClient }, userId) {
  typeCheck('userId::PositiveNumber', userId);

  if (state.get(['assignedApartmentLocator'])) {
    return;
  }

  await apiClient.postWithState({
    action: SR_API_ACTION_GET_ASSIGNED_APARTMENT_LOCATOR_BY_RENTER_ID,
    state: state,
    payload: {
      userId: userId,
    },
    onSuccess(apartmentLocator) {
      state.set(['assignedApartmentLocator'], apartmentLocator);
    },
  });
}
